<template>
    <div>
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <h3>Reason for visit</h3>
                <PetRequestedServiceList :requestedServices="requestedServices" />
            </div>
            <div v-if="dueServices.length>0" class="col-md-12 col-sm-12 col-xs-12">
                <h3>Services Due</h3>
                <PetDueServiceList :petDueServices="dueServices" />
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <h3>Comments</h3>
                <textarea rows="4" cols="50" class="form-control" v-model="VisitComments" placeholder="Please provide additional information regarding your reason for visit">
                </textarea>
                <span class="error" v-if="NoSickDetails">Comment is required to continue. </span>
            </div>
        </div>
        <div class="row" style="margin-top:30px;padding-bottom:100px;">
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__secondary pull-left" @click="goBack()">
                    Previous
                </button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 ">
                <button class="btn btn__primary pull-right" :disabled="!isAtLeastOneDueServiceIsSelected" @click="moveToNextPage()">
                    Next
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import PetRequestedServiceList from '../components/PetRequestedServiceList'
import PetDueServiceList from '../components/PetDueServiceList'
import { mapGetters } from 'vuex'

export default {
    name: 'PetServices',
    components: { PetRequestedServiceList, PetDueServiceList },
    data() {
        return {
            NoSickDetails: false
        }
    },
    computed: {
        ...mapGetters({
            requestedServices: 'requestedServices',
            isAtLeastOneDueServiceIsSelected: 'isAtLeastOneDueServiceIsSelected',
            selectedPractice: 'selectedPractice',
            dueServices: 'dueServices',
            selectedPet:'selectedPet',
            isSickAppointment:'isSickAppointment'
        }),
        VisitComments: {
            get() {
                return this.$store.state.VisitComments
            },
            set(value) {
                this.$store.commit('UpdateVisitComments', value)
            }
        },
    },
    created() {
        if (!this.selectedPractice) {
            this.$router.push({ name: 'Practices' })
        }
        if (this.petOwnerDetails && this.petOwnerDetails.FirstName == '') {
            this.$router.replace({ name: 'PetOwnerDetails' })
        }
        this.$store.dispatch('SetPageNumber', 4);
    },
    methods: {
        goBack() {
            if (this.selectedPet && this.selectedPet.PetId
                && this.selectedPet.PetId > 0) {
                this.$router.push({ name: 'PetList' })
            }
            else {
                this.$router.push({ name: 'NewPet' })
            }

        },
        moveToNextPage(pet) {
            if (this.VisitComments == '') {
                this.NoSickDetails = true;
            }
            else {
                this.$store.dispatch('ResetPracticeAvailableSlots');
                this.$store.dispatch('SetAppointmentType', this.isSickAppointment);
                this.$store.dispatch('GetPracticeAvailableSlots');
                this.$router.push({ name: 'AppointmentCalendar' })
            }

        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/PetServices.vue